<div class="button-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  @if (iconOnly()) {
    <!-- Icon-only variant (small square buttons for actions) -->
    <div
      class="tooltip-wrapper"
      (mouseenter)="onTooltipShow($event)"
      (mouseleave)="onTooltipHide()"
    >
      <button
        [class]="'btn btn--icon-only ' + getVariantClass()"
        [disabled]="disabled()"
        [attr.type]="'button'"
        (click)="onClick($event)"
      >
        <htx-icon class="btn-icon" [icon]="icon()"></htx-icon>
      </button>
    </div>
  } @else {
    <!-- Full button variant with text -->
    <div
      class="tooltip-wrapper"
      (mouseenter)="onTooltipShow($event)"
      (mouseleave)="onTooltipHide()"
    >
      <button
        [class]="
          'btn ' +
          getVariantClass() +
          ' ' +
          getSizeClass() +
          (fullWidth() ? ' btn--full-width' : '')
        "
        [disabled]="disabled()"
        [attr.type]="'button'"
        (click)="onClick($event)"
      >
        @if (icon() && iconPosition() === 'start' && !hasDropdown()) {
          <htx-icon class="btn-icon btn-icon--start" [icon]="icon()"></htx-icon>
        }
        <span class="btn-text">
          <ng-content></ng-content>
        </span>
        @if (icon() && iconPosition() === 'end' && !hasDropdown()) {
          <htx-icon class="btn-icon btn-icon--end" [icon]="icon()"></htx-icon>
        }
        @if (hasDropdown()) {
          <htx-icon
            class="btn-icon btn-icon--dropdown"
            [class.open]="isDropdownOpen()"
            [icon]="dropdownIcon()"
          ></htx-icon>
        }
      </button>
    </div>
  }

  @if (isTooltipVisible() && tooltip()) {
    <div class="fixed-tooltip" [style.top]="tooltipPos().top" [style.left]="tooltipPos().left">
      {{ tooltip() }}
      <div class="fixed-tooltip__arrow"></div>
    </div>
  }

  @if (hasDropdown() && isDropdownOpen()) {
    <div class="dropdown-menu" [class.dropdown-menu--right]="dropdownAlign() === 'right'">
      @if (dropdownHeader()) {
        <div class="dropdown-header">{{ dropdownHeader() }}</div>
      }
      @for (item of dropdownItems(); track item.value) {
        @if (hasChildren(item)) {
          <div
            class="dropdown-submenu-wrapper"
            (mouseenter)="openSubmenu(item)"
            (mouseleave)="closeSubmenu()"
          >
            <button
              class="dropdown-item dropdown-item--parent"
              [class.disabled]="item.disabled"
              [class.open]="openSubmenuValue() === item.value"
              [disabled]="item.disabled"
              type="button"
            >
              @if (item.icon) {
                <htx-icon [icon]="item.icon"></htx-icon>
              }
              <span>{{ item.label }}</span>
              <htx-icon class="dropdown-item__chevron" icon="chevron_right"></htx-icon>
            </button>
            @if (openSubmenuValue() === item.value) {
              <div
                class="dropdown-submenu"
                [class.dropdown-submenu--right]="dropdownAlign() === 'right'"
              >
                @for (child of item.children; track child.value) {
                  <button
                    class="dropdown-item"
                    [class.disabled]="child.disabled"
                    [disabled]="child.disabled"
                    (click)="selectDropdownItem(child)"
                  >
                    @if (child.icon) {
                      <htx-icon [icon]="child.icon"></htx-icon>
                    }
                    <span>{{ child.label }}</span>
                  </button>
                }
              </div>
            }
          </div>
        } @else {
          <button
            class="dropdown-item"
            [class.disabled]="item.disabled"
            [disabled]="item.disabled"
            (click)="selectDropdownItem(item)"
          >
            @if (item.icon) {
              <htx-icon [icon]="item.icon"></htx-icon>
            }
            <span>{{ item.label }}</span>
          </button>
        }
      }
    </div>
  }
</div>
